import React from "react";
import {
  faExclamationTriangle,
  faTimesCircle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

const FeePopupModal = ({ show, onHide, children }) => {
  return (
    <Modal
      style={{ marginLeft: "136px", marginTop: "285px" }}
      show={show}
      onHide={onHide}
    >
      <Modal.Body>
        <div className="close-buttonWarningModal text-right"></div>
        <div className="d-flex">{children}</div>
      </Modal.Body>
    </Modal>
  );
};

export default FeePopupModal;
